function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "decoB",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M345.64,491.5c-14.93,1.06-28.62-13.95-27.91-31.27.31-7.54,2.59-14.66,7.46-20.78,5.18-6.5,11.66-9.83,20.01-8.59,7.36,1.09,14.63,2.87,22.02,3.67,5.08.55,10.29-.07,15.44-.1,5.72-.03,12.84,4.62,13.65,8.63.49,2.47.12,4.18-2.49,5.08-2.83.97-5.54,2.76-8.41,3.03-5.39.51-7.9,3.88-9.6,8.21-1.52,3.85-2.54,7.9-3.89,11.83-4.7,13.72-13.29,20.32-26.29,20.29h.01ZM363.71,436.42c-1.8-.68-2.55-1.02-3.34-1.25-13.5-4.04-23.37-1.1-31.54,9.61-4.98,6.52-5.13,14.31-4.14,21.81,1.67,12.61,17.42,25.33,32.44,15.2,6.54-4.41,8.52-11.07,10.32-17.81,3.06-11.43,8.6-19.78,21.64-20.53,1.38-.08,2.73-.69,4.09-1.06-.19-.51-.38-1.03-.57-1.54-23.49-6.95-41.75-.66-53.41,22.77,2.12-14.28,11.73-21.57,24.53-27.2h-.02Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.71,438.42c-12.79,5.62-22.4,12.92-24.53,27.2,11.66-23.43,29.93-29.72,53.41-22.77.19.51.38,1.03.57,1.54-1.36.37-2.71.98-4.09,1.06-13.04.75-18.58,9.1-21.64,20.53-1.8,6.74-3.78,13.39-10.32,17.81-15.02,10.13-30.77-2.59-32.44-15.2-.99-7.49-.84-15.29,4.14-21.81,8.17-10.71,18.04-13.65,31.54-9.61.79.24,1.54.57,3.34,1.25h.02Z",
    style: {
      fill: "#a65252",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoB);
export default __webpack_public_path__ + "static/media/decoB.04f04fc660f8b843b38f61be5b0d526a.svg";
export { ForwardRef as ReactComponent };